const ROOT = {
  color: {
    aiax: {
      primary: '#583d6b',
      secondary: '#796489',
      tertiary: '#ab99b2',
      100: '#ded8e1',
    },
    triada: {
      morado: '#9c45de',
      cream: '#de9c45',
      aqua: '#45de9c',
    },
    gray: {
      100: '#f1f1f1',
      200: '#e4e4e4',
      300: '#b3b3b3',
      700: '#4d4d4d',
      900: '#1a1a1a',
    },
    gold: {
      primary: '#ffc107',
      secondary: '#ffd866',
    },
    orange: {
      primary: '#ff6347',
      secondary: '#fc8c79',
    },
  },
};

export default ROOT;
